import FunnelContainer from "./FunnelsContainer";

export default FunnelContainer;
